// Contenus SEO des pages métiers — textes uniques par secteur.
export const METIERS = [
  {
    slug: "restaurant",
    name: "Restaurants",
    icon: "utensils",
    h1: ["La carte qui fait", "revenir vos clients."],
    metaTitle: "Carte digitale NFC pour restaurant — Avis Google, menu, réseaux",
    metaDesc:
      "Carte digitale premium pour restaurant : vos clients approchent leur smartphone et accèdent à votre menu, vos avis Google, vos réseaux sociaux. À partir de 40 € TTC.",
    intro:
      "Sur la table, au comptoir ou présentée avec l'addition, votre carte Noveocard transforme chaque passage en connexion durable avec vos clients.",
    problem:
      "Un client ravi de son repas repart… et n'en parle nulle part. L'avis Google qu'il aurait volontiers laissé s'évapore, votre Instagram reste ignoré, et votre menu papier coûte cher à réimprimer à chaque saison. Le moment où votre client est le plus enthousiaste — à table, à la fin du service — est aussi le moment où vous ne captez rien.",
    useCases: [
      { t: "Récolter plus d'avis Google", d: "La carte est présentée avec l'addition : en un geste, le client tombe directement sur votre fiche d'avis, au moment où il est le plus satisfait." },
      { t: "Menu toujours à jour", d: "Votre carte ouvre votre menu digital : suggestions du jour, carte des vins, formules. Vous le faites évoluer sans réimprimer quoi que ce soit." },
      { t: "Contact en un geste", d: "WhatsApp et téléphone à portée de main : une privatisation, une question, un grand groupe — le client vous contacte sans chercher." },
      { t: "Gagner des abonnés", d: "Instagram et TikTok accessibles d'un geste : vos assiettes les plus photogéniques travaillent pour vous pendant le service." },
    ],
    benefits: [
      "Plus d'avis Google, donc une meilleure visibilité locale",
      "Un menu digital qui suit vos saisons sans coût d'impression",
      "Un contact direct avec vos clients, même après le service",
      "Une carte PVC premium à l'image de votre salle",
    ],
    example:
      "Imaginez une carte posée sur chaque table. En attendant l'addition, un client approche son téléphone : il découvre votre menu du moment, s'abonne à votre Instagram pour suivre vos prochaines soirées à thème, puis laisse un avis cinq étoiles en dix secondes. Un simple geste, trois bénéfices.",
    suggestedLinks: ["Google Avis", "Menu digital", "Instagram", "TikTok", "WhatsApp"],
  },
  {
    slug: "restaurant-gastronomique",
    name: "Restaurants haut de gamme",
    icon: "chef",
    h1: ["L'excellence, jusque", "dans le dernier geste."],
    metaTitle: "Carte digitale NFC pour restaurant gastronomique — Élégance et discrétion",
    metaDesc:
      "Carte digitale premium pour restaurant haut de gamme : présentée avec l'addition, elle ouvre votre livre d'or digital, vos avis Google et vos privatisations. À partir de 40 € TTC.",
    intro:
      "Dans une maison gastronomique, chaque détail compte. Votre carte Noveocard se glisse dans le porte-addition comme la dernière attention du service — discrète, élégante, mémorable.",
    problem:
      "Votre expérience est exceptionnelle, mais elle s'arrête à la porte. Vos hôtes ne savent pas toujours où laisser un mot, comment découvrir vos prochains menus, ni comment vous recommander. Et une carte de visite cartonnée, dans un cadre gastronomique, rompt l'harmonie que vous avez construite pendant trois heures.",
    useCases: [
      { t: "Un livre d'or digital", d: "Présentée avec l'addition, la carte invite vos hôtes à laisser un avis Google ou un message — avec la même élégance que votre service." },
      { t: "Privatisations et événements", d: "Un lien vers votre page dédiée : repas d'affaires, privatisation, accords mets et vins. Vos hôtes transmettent votre univers en un transfert." },
      { t: "Fidéliser une clientèle d'exception", d: "Accès direct à vos prochaines tables d'hôtes, menus de saison et actualités, pour que l'expérience continue après le dessert." },
    ],
    benefits: [
      "Un objet premium, à la hauteur de votre établissement",
      "Des avis précieux récoltés avec discrétion",
      "Une recommandation qui circule entre connaisseurs",
      "Aucune application, aucune friction pour vos hôtes",
    ],
    example:
      "Imaginez la fin d'un dîner. Le maître d'hôtel présente l'addition, accompagnée d'une carte bleu nuit gravée à vos couleurs. L'hôte approche son téléphone, découvre votre univers, s'abonne pour les prochains menus et confie la carte à son associé qui cherche une table pour un repas d'affaires.",
    suggestedLinks: ["Google Avis", "Privatisation", "Instagram", "Site web"],
  },
  {
    slug: "coiffeur",
    name: "Coiffeurs",
    icon: "scissors",
    h1: ["Votre salon, dans la", "poche de vos clientes."],
    metaTitle: "Carte digitale NFC pour salon de coiffure — Avis, Instagram, contact",
    metaDesc:
      "Carte digitale premium pour coiffeur : avis Google, Instagram avant/après et contact direct accessibles en un geste. À partir de 40 € TTC.",
    intro:
      "Posée à l'accueil ou glissée à la caisse, votre carte Noveocard transforme chaque fin de coupe en relation durable.",
    problem:
      "Votre cliente repart avec une coupe qu'elle adore — puis la vie reprend. Elle ne pense plus à votre salon, ne laisse pas d'avis, et ses amies qui complimentent sa coupe ne savent pas où vous trouver. Le bouche-à-oreille s'arrête faute de lien à partager.",
    useCases: [
      { t: "Rester joignable en un geste", d: "Téléphone et WhatsApp accessibles instantanément : vos clientes vous contactent sans jamais chercher votre numéro." },
      { t: "Transformer vos réalisations en vitrine", d: "Votre Instagram avant/après accessible instantanément : vos plus belles couleurs et coupes travaillent pour vous." },
      { t: "Faire circuler la recommandation", d: "Quand une amie demande « c'est qui ton coiffeur ? », la carte digitale se partage en un message." },
    ],
    benefits: [
      "Des clientes qui gardent le contact et reviennent",
      "Des avis Google qui rassurent les nouvelles clientes",
      "Une vitrine Instagram qui grandit à chaque coupe",
      "Un objet premium qui prolonge l'expérience salon",
    ],
    example:
      "Imaginez : votre cliente règle, on lui tend la carte avec le miroir. Elle approche son téléphone, laisse un avis pendant qu'on lui fait son brushing, et envoie votre page à sa sœur dans la foulée.",
    suggestedLinks: ["Google Avis", "Instagram", "WhatsApp", "Téléphone", "Tarifs & prestations"],
  },
  {
    slug: "barbier",
    name: "Barbiers",
    icon: "razor",
    h1: ["Le geste qui fidélise", "autant que la lame."],
    metaTitle: "Carte digitale NFC pour barbier — Avis, réseaux sociaux, contact",
    metaDesc:
      "Carte digitale premium pour barbier : vos clients laissent un avis et suivent vos transformations en approchant leur smartphone. À partir de 40 € TTC.",
    intro:
      "Un barbershop vit de son style et de sa communauté. Votre carte Noveocard met les deux à portée de geste, dès la sortie du fauteuil.",
    problem:
      "Votre client sort du fauteuil avec un dégradé parfait et filme le résultat… mais il ne tague pas votre compte, ne pense pas à revenir, et votre concurrent d'en face récolte les avis Google à votre place. La fidélité d'un barbu se joue aussi entre deux visites.",
    useCases: [
      { t: "Le contact qui reste", d: "Téléphone et WhatsApp en un geste : le client vous retrouve instantanément quand vient l'heure de la prochaine retouche." },
      { t: "Vos transformations en avant", d: "TikTok et Instagram en un geste : vos dégradés et contours deviennent votre meilleure publicité locale." },
      { t: "Avis Google au bon moment", d: "Cinq étoiles laissées en dix secondes, encore assis dans le fauteuil, avant que le quotidien ne reprenne le dessus." },
    ],
    benefits: [
      "Une fidélité qui se construit dès la première visite",
      "Une communauté qui grandit à chaque coupe",
      "Un positionnement premium, du fauteuil à l'objet",
      "Zéro application, zéro friction pour vos clients",
    ],
    example:
      "Imaginez : votre client admire le résultat, vous lui tendez la carte. Il approche son téléphone, suit votre TikTok et poste un avis avec la photo de son dégradé. Il quitte le shop, votre image part avec lui.",
    suggestedLinks: ["TikTok", "Instagram", "Google Avis", "WhatsApp", "Téléphone"],
  },
  {
    slug: "institut-beaute",
    name: "Instituts de beauté",
    icon: "sparkles",
    h1: ["Prolongez le soin", "au-delà de la cabine."],
    metaTitle: "Carte digitale NFC pour institut de beauté — Soins, avis, contact",
    metaDesc:
      "Carte digitale premium pour institut de beauté et spa : carte des soins, avis Google et contact direct en un geste. À partir de 40 € TTC.",
    intro:
      "Dans un institut, tout est affaire de détail et de sérénité. Votre carte Noveocard prolonge cette sensation, du comptoir d'accueil au quotidien de vos clientes.",
    problem:
      "Une cliente détendue après son soin ne veut pas chercher votre numéro ni votre site. Elle repart apaisée… et le lien se distend. Vos rituels, vos offres du moment et vos cartes cadeaux restent invisibles une fois la porte franchie.",
    useCases: [
      { t: "Le contact en apesanteur", d: "Un geste sur la carte à l'accueil et votre cliente retrouve votre WhatsApp ou votre ligne directe, encore dans la bulle de son massage." },
      { t: "Carte des soins toujours à jour", d: "Rituels saisonniers, nouveautés, cartes cadeaux : votre carte ouvre une carte des soins qui évolue sans réimpression." },
      { t: "Avis et abonnées en douceur", d: "Google Avis et Instagram accessibles d'un geste, sans jamais briser l'ambiance feutrée de votre institut." },
    ],
    benefits: [
      "Des clientes qui gardent le contact en douceur",
      "Une image premium cohérente avec votre univers bien-être",
      "Vos offres et nouveautés visibles entre deux soins",
      "Un objet élégant que vos clientes gardent et montrent",
    ],
    example:
      "Imaginez : au comptoir, votre hôtesse remet la carte avec la tisane. La cliente approche son téléphone dans le salon de repos, découvre le nouveau rituel du mois et vous écrit pour offrir une carte cadeau à sa meilleure amie — sans quitter son fauteuil.",
    suggestedLinks: ["Carte des soins", "Google Avis", "Instagram", "WhatsApp", "Cartes cadeaux"],
  },
  {
    slug: "boutique",
    name: "Boutiques",
    icon: "bag",
    h1: ["Votre boutique ne ferme", "plus jamais vraiment."],
    metaTitle: "Carte digitale NFC pour boutique et commerce — Réseaux, avis, itinéraire",
    metaDesc:
      "Carte digitale premium pour boutique : nouveautés Instagram, WhatsApp pour la dispo d'un produit, avis Google et itinéraire en un geste. À partir de 40 € TTC.",
    intro:
      "Près de la caisse ou glissée dans le sac, votre carte Noveocard garde le lien avec vos clientes bien après la fermeture du rideau.",
    problem:
      "Une cliente hésite devant une pièce, repart « pour réfléchir »… et ne revient pas, faute de moyen simple de vous recontacter. Vos nouveautés postées sur Instagram n'atteignent pas vos clientes de passage, et les touristes qui adorent votre boutique ne savent pas la recommander.",
    useCases: [
      { t: "Le lien qui reste dans le sac", d: "Glissée avec l'achat, la carte donne accès à vos nouveautés, vos horaires et votre WhatsApp : la cliente revient, en ligne ou en boutique." },
      { t: "Disponibilité en un message", d: "« Vous avez encore ce modèle en 38 ? » — un geste sur la carte ouvre votre WhatsApp, la vente se conclut à distance." },
      { t: "Être trouvée et recommandée", d: "Itinéraire, avis Google et Instagram accessibles d'un geste : votre boutique se partage aussi facilement qu'une photo." },
    ],
    benefits: [
      "Des clientes de passage transformées en clientes fidèles",
      "Des ventes qui se poursuivent sur WhatsApp",
      "Une communauté locale qui suit vos nouveautés",
      "Une image de marque soignée jusque dans l'objet",
    ],
    example:
      "Imaginez : une touriste adore votre vitrine mais part le soir même. Elle approche la carte présentée à la caisse, suit votre Instagram, et deux semaines plus tard vous écrit sur WhatsApp pour se faire livrer la pièce qu'elle regrettait.",
    suggestedLinks: ["Instagram", "WhatsApp", "Google Avis", "Itinéraire", "Site / e-shop"],
  },
  {
    slug: "garage",
    name: "Garages",
    icon: "wrench",
    h1: ["La confiance commence", "avant le capot."],
    metaTitle: "Carte digitale NFC pour garage automobile — Contact, itinéraire, avis Google",
    metaDesc:
      "Carte digitale premium pour garage et concession : itinéraire, téléphone direct et avis Google en un geste. À partir de 40 € TTC.",
    intro:
      "Au comptoir d'accueil ou remise avec les clés, votre carte Noveocard rassure vos clients et leur donne toutes vos coordonnées en un geste.",
    problem:
      "Entre deux entretiens, vos clients vous oublient. Le voyant qui s'allume à 21 h, le pneu crevé un dimanche : ils cherchent « garage près de moi » et tombent sur n'importe qui. Vos bons clients n'ont pas votre numéro sous la main, et les nouveaux se fient aux avis — que vos clients satisfaits ne prennent jamais le temps de laisser.",
    useCases: [
      { t: "Rester le réflexe n°1", d: "Remise avec les clés après chaque intervention, la carte garde votre téléphone, votre WhatsApp et votre itinéraire à portée de geste dans la boîte à gants." },
      { t: "Des avis qui inspirent confiance", d: "L'automobile est un secteur de confiance : la carte oriente vos clients satisfaits vers Google Avis au moment de la restitution." },
      { t: "Ligne directe simplifiée", d: "Téléphone et WhatsApp en un geste : le client vous joint en dix secondes pour sa révision ou une question." },
    ],
    benefits: [
      "Vos clients ne cherchent plus jamais vos coordonnées",
      "Des avis Google qui rassurent avant la première visite",
      "Un accueil moderne, à la hauteur de votre atelier",
      "Parfait aussi pour concessions et centres auto",
    ],
    example:
      "Imaginez : trois mois après une réparation, un voyant s'allume. Le client ouvre sa boîte à gants, approche la carte et vous appelle directement — au lieu de taper « garage » dans Google et de tomber sur un inconnu.",
    suggestedLinks: ["Téléphone", "WhatsApp", "Itinéraire", "Google Avis", "Site web"],
  },
  {
    slug: "hotel",
    name: "Hôtels & gîtes",
    icon: "bed",
    h1: ["La conciergerie,", "en un geste."],
    metaTitle: "Carte digitale NFC pour hôtel et gîte — Conciergerie digitale et avis",
    metaDesc:
      "Carte digitale premium pour hôtel et gîte : Wi-Fi, room service et avis Google accessibles en approchant le smartphone. À partir de 40 € TTC.",
    intro:
      "Posée dans la chambre ou à la réception, votre carte Noveocard devient la conciergerie digitale de vos hôtes — et votre meilleur outil de fidélisation.",
    problem:
      "Vos hôtes posent toujours les mêmes questions : le code Wi-Fi, les horaires du petit-déjeuner, un bon restaurant alentour. Et au départ, ils repartent sans laisser d'avis — et sans moyen simple de garder le contact avec votre établissement.",
    useCases: [
      { t: "La chambre qui répond aux questions", d: "Une carte posée sur le bureau : Wi-Fi, horaires, room service, recommandations locales — vos hôtes trouvent tout, sans appeler la réception." },
      { t: "Des avis au moment du départ", d: "Présentée au check-out, la carte capte l'avis Google quand le séjour est encore frais dans les esprits." },
      { t: "Le lien direct qui reste", d: "Vos hôtes gardent votre site et votre ligne directe sous la main : leur prochain séjour se prépare avec vous, en direct." },
    ],
    benefits: [
      "Une expérience hôte moderne et fluide, jour et nuit",
      "Plus d'avis Google pour votre visibilité locale",
      "Un contact direct avec vos hôtes, même après le départ",
      "Un objet premium à l'image de votre établissement",
    ],
    example:
      "Imaginez : un couple arrive à 22 h. Un geste sur la carte de la chambre : code Wi-Fi, carte du room service, vos adresses de restaurants préférées. Au départ, même geste : l'avis Google est laissé dans le taxi, et votre site enregistré en favori pour le prochain séjour.",
    suggestedLinks: ["Wi-Fi & infos séjour", "Room service / menu", "Google Avis", "Site web", "Itinéraire"],
  },
  {
    slug: "agent-immobilier",
    name: "Agents immobiliers",
    icon: "key",
    h1: ["Chaque contact devient", "une opportunité."],
    metaTitle: "Carte digitale NFC pour agent immobilier — Contact, biens, avis en un geste",
    metaDesc:
      "Carte digitale premium pour agent immobilier et agence : fiche contact, WhatsApp, biens du moment et avis Google accessibles en approchant le smartphone. À partir de 40 € TTC.",
    intro:
      "En visite, en estimation ou en salon, votre carte Noveocard transmet tout votre univers professionnel en un seul geste.",
    problem:
      "L'immobilier est un métier de timing et de confiance. Une carte de visite papier finit au fond d'une poche ; un acheteur rencontré en visite vous perd de vue ; un vendeur hésitant ne vous rappelle pas. Et quand on vous recommande, votre numéro se transmet mal, se recopie mal, se perd.",
    useCases: [
      { t: "Votre fiche contact, toujours à jour", d: "Un geste et vos prospects enregistrent votre fiche contact complète : nom, téléphone, WhatsApp, agence. Fini les numéros gribouillés." },
      { t: "Vos biens du moment en poche", d: "Lien vers vos annonces : le visiteur repart avec votre catalogue et le partage à son conjoint le soir même." },
      { t: "La preuve par les avis", d: "En estimation, vos avis Google rassurent immédiatement : la recommandation de vos anciens clients vend pour vous." },
    ],
    benefits: [
      "Une image premium qui marque dès la première rencontre",
      "Zéro contact perdu : tout s'enregistre dans le téléphone",
      "Vos annonces partagées en un geste après chaque visite",
      "Idéal pour équiper toute une agence (packs 4 cartes et plus)",
    ],
    example:
      "Imaginez une visite qui se termine sur le pas de la porte. L'acheteur approche votre carte : votre fiche contact s'enregistre, il envoie la page à sa compagne avec les photos du bien, et vous écrit pour une seconde visite — avant même que vous ayez regagné l'agence.",
    suggestedLinks: ["Fiche contact", "WhatsApp", "Biens du moment", "Google Avis", "Site web"],
  },
  {
    slug: "artisan",
    name: "Artisans",
    icon: "hammer",
    h1: ["Votre réputation,", "toujours sous la main."],
    metaTitle: "Carte digitale NFC pour artisan — Avis Google, réalisations, contact direct",
    metaDesc:
      "Carte digitale premium pour artisan et professionnel du BTP : avis Google, photos de chantiers et contact direct en approchant le smartphone. À partir de 40 € TTC.",
    intro:
      "Sur un chantier, chez un client ou à la remise d'un ouvrage, votre carte Noveocard présente vos réalisations et capte vos avis en un geste.",
    problem:
      "Votre meilleur commercial, c'est le bouche-à-oreille. Mais quand un client satisfait veut vous recommander, il n'a rien sous la main : ni vos photos de chantiers, ni vos avis, ni un lien simple à transférer. Et sur un devis en concurrence, celui qui rassure le plus vite emporte le chantier.",
    useCases: [
      { t: "Vos réalisations comme argument", d: "Un geste et le client découvre vos chantiers avant/après sur Instagram ou votre site : la preuve par l'image, immédiate." },
      { t: "Des avis qui travaillent pour vous", d: "En fin de chantier, la carte oriente votre client vers Google Avis : votre réputation locale grandit à chaque ouvrage livré." },
      { t: "Recommandation sans friction", d: "« Tu peux m'envoyer son contact ? » — votre page digitale se transfère en un message, avec téléphone, WhatsApp et zone d'intervention." },
    ],
    benefits: [
      "Une image pro et moderne qui rassure dès le premier contact",
      "Des avis Google qui font la différence face aux concurrents",
      "Un contact direct : appel ou WhatsApp en un geste",
      "Une carte solide en PVC, pensée pour la vie de chantier",
    ],
    example:
      "Imaginez : vous venez de poser une cuisine. Le client est ravi, sa voisine passe au même moment. Il approche la carte, lui montre vos réalisations sur votre page, et elle vous écrit sur WhatsApp pour son propre projet dans la minute.",
    suggestedLinks: ["Téléphone", "WhatsApp", "Google Avis", "Réalisations (Instagram / site)", "Zone d'intervention"],
  },
  {
    slug: "entreprise",
    name: "Entreprises & équipes",
    icon: "building",
    h1: ["Une identité d'équipe,", "en un seul geste."],
    metaTitle: "Cartes digitales NFC pour entreprise et équipes — Networking premium",
    metaDesc:
      "Cartes digitales premium pour entreprises, dirigeants et équipes : fiche contact, LinkedIn et plaquette en un geste. Packs sur mesure, à partir de 40 € TTC la carte.",
    intro:
      "Dirigeants, commerciaux, équipes en salon : Noveocard équipe votre entreprise de cartes digitales cohérentes, élégantes et mémorables.",
    problem:
      "En déplacement ou en salon, l'échange de coordonnées est un moment clé… gâché par des cartes papier perdues, froissées ou jamais ressaisies. Multipliez par le nombre de collaborateurs : chaque carte jetée, c'est un contact professionnel qui s'évapore et une image de marque qui se dilue.",
    useCases: [
      { t: "Le networking sans faute", d: "Un geste et votre interlocuteur enregistre la fiche contact complète du collaborateur : fonction, téléphone, LinkedIn, e-mail. Zéro ressaisie, zéro perte." },
      { t: "Une marque cohérente à grande échelle", d: "Même design, mêmes couleurs, contenus personnalisés par collaborateur : vos packs sur mesure déploient votre identité sur tout le terrain." },
      { t: "Votre plaquette en poche", d: "Site web, plaquette commerciale, présentation : votre prospect repart avec tout votre argumentaire, encore sur place." },
    ],
    benefits: [
      "Une image premium et uniforme pour toute l'équipe",
      "Chaque contact terrain enregistré, jamais perdu",
      "Des contenus modifiables sans réimprimer les cartes",
      "Packs 4 cartes (80 € TTC) et packs sur mesure",
    ],
    example:
      "Imaginez votre équipe sur un salon. Chaque visiteur approche la carte de votre commercial : sa fiche contact s'enregistre, votre plaquette s'ouvre. Le soir, aucune carte papier à ressaisir — les contacts sont déjà dans les téléphones.",
    suggestedLinks: ["Fiche contact", "LinkedIn", "Site web", "Plaquette / présentation"],
  },
];
